import React, { useState } from "react"
import PropTypes from "prop-types"

/**
 * Pastilla con CUFE truncado + botón para copiar el CUFE completo al clipboard.
 * Muestra check verde por 1.5s como feedback. Tooltip con el CUFE completo.
 *
 * Props:
 *  - cufe: string completo (obligatorio)
 *  - chars: cantidad de caracteres del prefijo a mostrar (default 14)
 *  - showLabel: si true, muestra "CUFE:" antes del valor (default true)
 *  - compact: si true, fondo transparente sin pastilla (default false)
 */
const CopiarCufe = ({ cufe, chars = 14, showLabel = true, compact = false }) => {
  const [copiado, setCopiado] = useState(false)

  const copiar = async e => {
    e.stopPropagation()
    if (!cufe) return
    try {
      await navigator.clipboard.writeText(cufe)
      setCopiado(true)
      setTimeout(() => setCopiado(false), 1500)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = cufe
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand("copy")
        setCopiado(true)
        setTimeout(() => setCopiado(false), 1500)
      } catch { /* noop */ }
      document.body.removeChild(ta)
    }
  }

  if (!cufe) return null

  const baseStyle = compact
    ? { padding: 0 }
    : { background: "#f1f5f9", padding: "2px 8px", borderRadius: 6 }

  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: 11,
      color: "#475569",
      fontFamily: "ui-monospace, SFMono-Regular, monospace",
      ...baseStyle,
    }}>
      <span title={cufe}>
        {showLabel && "CUFE: "}{cufe.substring(0, chars)}…
      </span>
      <button
        type="button"
        onClick={copiar}
        title={copiado ? "Copiado" : "Copiar CUFE completo"}
        style={{
          background: "none", border: "none", padding: 0, cursor: "pointer",
          color: copiado ? "#10b981" : "#64748b",
          display: "inline-flex", alignItems: "center",
          transition: "color 0.15s",
        }}
      >
        <i className={`mdi mdi-${copiado ? "check" : "content-copy"}`} style={{ fontSize: 14 }} />
      </button>
    </span>
  )
}

CopiarCufe.propTypes = {
  cufe: PropTypes.string,
  chars: PropTypes.number,
  showLabel: PropTypes.bool,
  compact: PropTypes.bool,
}

export default CopiarCufe
